import messages from './messages';

export const notificationTypeToNotificationProperties = {
	MULTIPLE_APPS_CONFLICTS: {
		message: messages.multipleAppsConflicted,
		type: 'warning' as const,
	},
};
